// extracted by mini-css-extract-plugin
module.exports = {"slNavbar":"styles_slNavbar__12mL8","socialLinks":"styles_socialLinks__1kWps"};